// NPM Imports
import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * PageLoader
 * - this component is for showing the
 * - blank page layout while fetching the data
 * - as of now, it is for pipeline page only, will update it later
 */

const PageLoader = props => {
  const {
    page,
    leftSecTotalList,
    rightSecTotoalList,
    totalLanes,
    totalLaneCards,
    showLeftSec,
    showTopSec,
    showRightSec,
  } = props;

  const assetLeftSectionList = [];
  if (leftSecTotalList) {
    for (let i = 0; i < leftSecTotalList; i += 1) {
      assetLeftSectionList.push(
        <div className="pageloader-leftsection-list" key={i}>
          <span className="pageloader-leftsection-listitem3" />
          <span className="pageloader-leftsection-listitem2 ripple-container" />
        </div>,
      );
    }
  }

  const pipelineSwimlaneCardsView = [];
  if (totalLaneCards) {
    for (let i = 0; i < totalLaneCards; i += 1) {
      pipelineSwimlaneCardsView.push(
        <div className="pageloader-lane-card" key={i} />,
      );
    }
  }

  const pipelineOpportinitiesView = [];
  if (leftSecTotalList) {
    for (let i = 0; i < leftSecTotalList; i += 1) {
      pipelineOpportinitiesView.push(
        <div className="pageloader-leftsection-list" key={i}>
          <span className="pageloader-leftsection-listitem1" />
          <span className="pageloader-leftsection-listitem2 ripple-container" />
          <span className="pageloader-leftsection-listitem3" />
        </div>,
      );
    }
  }

  const pipelineSwimLanesView = [];
  if (totalLanes) {
    for (let i = 0; i < totalLanes; i += 1) {
      pipelineSwimLanesView.push(
        <div className="pageloader-rightsection-lane" key={i}>
          <div className="pageloader-lane-header">
            <div className="pageloader-lane-headersec1 ripple-container" />
            <div className="pageloader-lane-headersec2" />
          </div>
          {pipelineSwimlaneCardsView}
        </div>,
      );
    }
  }

  const hedaerTitle = (
    <div className="pageloader-header-title-wrapper">
      <span className="pageloader-rightsection-headericon" />
      <div className="pageloader-rightsection-headerinfo">
        <div className="pageloader-rightsection-headertitle ripple-container" />
        <div className="pageloader-rightsection-headermeta ripple-container" />
      </div>
    </div>
  );

  const tableHeader = (
    <div className="pageloader-table-header-container">
      <div className="pageloader-table-row">
        <div className="pageloader-table-col ripple-container" />
        <div className="pageloader-table-col ripple-container" />
        <div className="pageloader-table-col ripple-container" />
        <div className="pageloader-table-col ripple-container" />
      </div>
    </div>
  );

  const _tableBody = () => {
    const list = [];
    for (let i = 0; i < rightSecTotoalList; i += 1) {
      list.push(
        <div className="pageloader-list-item ripple-container" key={i} />,
      );
    }
    return list;
  };

  const _assetLeftSec = () => (
    <div className="pageloader-leftsection-wrapper">
      <div className="pageloader-leftsection-list">
        <span className="pageloader-leftsection-listitem3" />
        <span className="pageloader-leftsection-listitem2 ripple-container" />
      </div>
      <div className="pageloader-leftsection-listwrapper">
        {assetLeftSectionList}
      </div>
    </div>
  );

  const _pipelineLeftSec = () => (
    <div className="pageloader-leftsection-wrapper">
      <div className="pageloader-leftsection-accountsec">
        <span className="pageloader-leftsection-label1 ripple-container" />
        <span className="pageloader-leftsection-label2" />
      </div>

      <div className="pageloader-leftsection-listwrapper">
        {pipelineOpportinitiesView}
      </div>
    </div>
  );

  const _assetRightSec = () => (
    <div className="pageloader-rightsection-wrapper">
      {/* Right Hedaer Section */}
      {tableHeader}
      {/* Right Main Section */}
      <div className="pageloader-rightsection-lanewrapper">
        <div className="pageloader-table-container">{_tableBody()}</div>
      </div>
    </div>
  );

  const _pipelineRightSec = () => (
    <div className="pageloader-rightsection-wrapper">
      {/* Right Hedaer Section */}
      {hedaerTitle}

      {/* Right Main Section */}
      <div className="pageloader-rightsection-lanewrapper">
        {pipelineSwimLanesView}
      </div>
    </div>
  );

  const _deviceTopSec = () => {
    if (showTopSec) {
      return <div className="pageloader-header">{hedaerTitle}</div>;
    }
    return null;
  };

  const _deviceLeftSec = () => {
    if (showLeftSec) {
      switch (page) {
        case "ASSET":
          return _assetLeftSec();
        case "PIPELINE":
          return _pipelineLeftSec();
        default:
          return _assetLeftSec();
      }
    }
    return null;
  };

  const _deviceRightSec = () => {
    if (showRightSec) {
      switch (page) {
        case "ASSET":
          return _assetRightSec();
        case "PIPELINE":
          return _pipelineRightSec();
        default:
          return _assetRightSec();
      }
    }
    return null;
  };

  return (
    <div
      className={`pageloader-wrapper ${props.isFullPage &&
        "full-page-loader"}`}>
      {/* Header Section */}
      {_deviceTopSec()}

      <div className="pageloader-mainsection-wrapper">
        {/* Left Section */}
        {_deviceLeftSec()}

        {/* Right Section */}
        {_deviceRightSec()}
      </div>
    </div>
  );
};

export default PageLoader;



// WEBPACK FOOTER //
// ./src/commonComponents/PageLoader/index.js